export default __webpack_public_path__ + "static/iso-press-hover-113d83a772d79f401f717a31259b9cae.jpg";